const AppInventoryManagement =()=> import( './inventory-management.vue');
const AppSupplyChain =()=> import( './supply-chain.vue');

const PurchaseManagement =()=> import( './purchase-management/purchase-management.vue');
const PMSetups =()=> import( './purchase-management/setups/setups.vue');
const VendorSetup =()=> import( './purchase-management/setups/vendor-setup/vendor-setup.vue');
const PurchaseOperations =()=> import( './purchase-management/purchase-operations/operations.vue');
const IMSetups =()=> import( './setups/setups.vue');
const PdtSetup =()=> import( './setups/product-setup/product-setup.vue');
const WHSetup =()=> import( './setups/warehouse-setup/warehouse-setup.vue');
const IMOperations =()=> import( './inventory-management/inventory-operations/inventory-operations.vue');
const ClassificationAssignment = () => import('./setups/product-setup/classification-assignment/classification-assignment.vue');

// Product Category
const ProductCategory = () => import('./setups/product-setup/product-category/product-category.vue')
const ProductCategoryList = () => import('./setups/product-setup/product-category/product-category-list/product-category-list.vue');
const NewProductCategory = () => import('./setups/product-setup/product-category/new-product-category/new-product-category.vue');

const UOMCategory = () => import('./setups/product-setup/uom-category/uom-category.vue')

const MaterialsBill = () => import('./setups/product-setup/materials-bill/materials-bill.vue')

// Products
const Products = () => import('./setups/product-setup/products/products.vue');
const ProductsList = () => import('./setups/product-setup/products/products-list/products-list.vue');
const NewProduct = () => import('./setups/product-setup/products/new-product/new-product.vue');

 // WareHouse
const Warehouse = () => import('./setups/warehouse-setup/warehouse/warehouse.vue')
const WarehouseList = () => import('./setups/warehouse-setup/warehouse/warehouse-list/warehouse-list.vue');
const NewWarehouse = () => import('./setups/warehouse-setup/warehouse/new-warehouse/new-warehouse.vue');

// WareHouse Category
const WarehouseCategory = () => import('./setups/warehouse-setup/warehouse-category/warehouse-category.vue');
const WarehouseCategoryList = () => import('./setups/warehouse-setup/warehouse-category/warehouse-category-list/warehouse-category-list.vue');

// Item tracking
const ItemsTracking = () => import('./setups/warehouse-setup/items-tracking/items-tracking.vue');

// Data Migration
const BulkSetup = () => import('./setups/bulk-setup/bulk-setup.vue');

// Warehouse location
const WarehouseLocation = () => import('./setups/warehouse-setup/warehouse-location/warehouse-location.vue');
const WarehouseLocationList = () => import('./setups/warehouse-setup/warehouse-location/warehouse-location-list/warehouse-location-list.vue');
const NewWarehouseLocation = () => import('./setups/warehouse-setup/warehouse-location/new-warehouse-location/new-warehouse-location.vue');
const EditWarehouseLocation = () => import('./setups/warehouse-setup/warehouse-location/edit-warehouse-location/edit-warehouse-location.vue');

// Internal Transfer between locations
const InternalTransfer = () => import('./inventory-management/inventory-operations/internal-transfer/internal-transfer.vue');
const InternalTransferList = () => import('./inventory-management/inventory-operations/internal-transfer/internal-transfer-list/internal-transfer-list.vue');
const NewInternalTransfer = () => import('./inventory-management/inventory-operations/internal-transfer/new-internal-transfer/new-internal-transfer.vue');


// Purchase orders
const PurchaseOrders = () => import('./purchase-management/purchase-operations/purchase-orders/purchase-orders.vue')
const PurchaseOrdersList = () => import('./purchase-management/purchase-operations/purchase-orders/purchase-orders-list/purchase-orders-list.vue')
const NewPurchaseOrder = () => import('./purchase-management/purchase-operations/purchase-orders/new-purchase-order/new-purchase-order.vue')
const ViewPurchaseOrder = () => import('./purchase-management/purchase-operations/purchase-orders/view-purchase-order/view-purchase-order.vue')

// Vendor list
const vendor = () => import('./purchase-management/setups/vendor-setup/vendor/vendor.vue')
const VendorList = () => import('./purchase-management/setups/vendor-setup/vendor/vendor-list/vendor-list.vue')
const NewVendor = () => import('./purchase-management/setups/vendor-setup/vendor/new-vendor/new-vendor.vue')

// vendor group
const vendorGroup = () => import('./purchase-management/setups/vendor-setup/vendor-group/vendor-group.vue')
const vendorGroupList = () => import('./purchase-management/setups/vendor-setup/vendor-group/vendor-group-list/vendor-group-list.vue')
const NewVendorGroup = () => import('./purchase-management/setups/vendor-setup/vendor-group/new-vendor-group/new-vendor-group.vue')

// Internal Request
const InternalRequest = () => import('./inventory-management/inventory-operations/internal-request/internal-request.vue')
const InternalRequestList = () => import('./inventory-management/inventory-operations/internal-request/internal-request-list/internal-request-list.vue')
const NewInternalRequest = () => import('./inventory-management/inventory-operations/internal-request/new-request-list/new-internal-request.vue')

// purchse Requistion
const PurchaseRequistion = () => import('./inventory-management/inventory-operations/purchase-requistion/purchase-requistion.vue')
const NewPurchaseRequistion = () => import('./inventory-management/inventory-operations/purchase-requistion/new-purchase-requistion/new-purchase-requistion.vue')
const PurchaseRequistionList = () => import('./inventory-management/inventory-operations/purchase-requistion/purchase-requistion-list/purchase-requistion-list.vue')

//Goods Reciepts
const GoodsReceipt = () => import('./inventory-management/inventory-operations/goods-receipt/goods-receipt.vue')
const GoodsReceiptList = () => import('./inventory-management/inventory-operations/goods-receipt/goods-receipt-list/goods-receipt-list.vue')
const NewGoodsReceipt = () => import('./inventory-management/inventory-operations/goods-receipt/new-goods-receipt/new-goods-receipt.vue')

//Transfer Out
const TransferOut = () => import('./inventory-management/inventory-operations/transfer-out/transfer-out.vue')
const TransferOutList = () => import('./inventory-management/inventory-operations/transfer-out/transfer-out-list/transfer-out-list.vue')
const NewTransferOut = () => import('./inventory-management/inventory-operations/transfer-out/new-transfer-out/new-transfer-out.vue')

//Transfer In
const TransferIn = () => import('./inventory-management/inventory-operations/transfer-in/transfer-in.vue')
const TransferInList = () => import('./inventory-management/inventory-operations/transfer-in/transfer-in-list/transfer-in-list.vue')
const NewTransferIn = () => import('./inventory-management/inventory-operations/transfer-in/new-transfer-in/new-transfer-in.vue')

// Donations
const Donations = () => import('./inventory-management/inventory-operations/donations/donations.vue')
const DonationsList = () => import('./inventory-management/inventory-operations/donations/donations-list/donations-list.vue')
const ViewDonation = () => import('./inventory-management/inventory-operations/donations/view-donation/view-donation.vue');

// Returns to WH
const ReturnsToWH = () => import('./inventory-management/inventory-operations/returns/returns.vue')
const ReturnsToWHList = () => import('./inventory-management/inventory-operations/returns/return-wh-list/return-wh-list.vue')
const ReceiveReturn = () => import('./inventory-management/inventory-operations/returns/receive-return/receive-return.vue')

// Returns to vendor
const ReturnToVendor = () => import('./inventory-management/inventory-operations/return-to-vendor/return-to-vendor.vue')
const ReturnToVendorList = () => import('./inventory-management/inventory-operations/return-to-vendor/return-to-vendor-list/return-to-vendor-list.vue')
const NewReturnToVendor = () => import('./inventory-management/inventory-operations/return-to-vendor/new-return-to-vendor/new-return-to-vendor.vue')

// Stock Count
const StockCount = () => import('./inventory-management/inventory-operations/stock-count/stock-count.vue')
const StockCountList = () => import('./inventory-management/inventory-operations/stock-count/stock-count-list/stock-count-list.vue')
const NewStockCount = () => import('./inventory-management/inventory-operations/stock-count/new-stock-count/new-stock-count.vue')

// Stock Count from browser
const NewStockCountFromBrowser = () => import('./inventory-management/inventory-operations/stock-count/new-stock-count-from-browser/new-stock-count-from-browser.vue')

// Receive IR
const ReceiveIR = () => import('./inventory-management/inventory-operations/receive-ir/receive-ir.vue')
const ReceiveIRList = () => import('./inventory-management/inventory-operations/receive-ir/receive-ir-list/receive-ir-list.vue')
const ReceiveIRRequest = () => import('./inventory-management/inventory-operations/receive-ir/receive-ir/receive-ir.vue')

// Manufacturing Orders
const ManufacturingOrders = () => import('./inventory-management/inventory-operations/manufacturing-orders/manufacturing-orders.vue')
const ManufacturingOrdersList = () => import('./inventory-management/inventory-operations/manufacturing-orders/manufacturing-order-list/manufacturing-order-list.vue')
const NewManufacturingOrder = () => import('./inventory-management/inventory-operations/manufacturing-orders/new-manufacturing-order/new-manufacturing-order.vue')

//Products limits
const ProductsLimits = () => import('./setups/warehouse-setup/products-limits/products-limits.vue')

//Requisitions
const Requisitions = () => import('./purchase-management/purchase-operations/Requisitions/requisitions.vue')
const RequisitionsList = () => import('./purchase-management/purchase-operations/Requisitions/requisitions-list/requisitions-list.vue')

// Donations
const RsdNotifications = () => import('./inventory-management/inventory-operations/rsd-notification/rsd-notification.vue')
const RsdNotificationsList = () => import('./inventory-management/inventory-operations/rsd-notification/rsd-notification-list/rsd-notification-list.vue')


import { guardRoute } from '../guardRouter';

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'


export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}


const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const inventoryManagementRoutes = [
    {
        path: '/supply-chain',
        name: 'app.SupplyChain',
        component: AppSupplyChain,
        meta: {
            title: translation[lang].Nav.Inventory.SupplyChain
        },
        children: [
            {
                path: 'inventory-management',
                name: 'app.InventoryManagement',
                component: AppInventoryManagement,
                meta: {
                    title: translation[lang].Nav.Inventory.InventoryManagement
                },
                children: [
                    {
                        path: 'setups',
                        component: IMSetups,
                        meta: {
                            title: translation[lang].Nav.Inventory.Setups
                        },
                        children: [
                            {
                                path: 'warehouse-setup',
                                component: WHSetup,
                                meta: {
                                    title: translation[lang].Nav.Inventory.WarehouseSetup
                                },
                                children: [
                                    {
                                        path: 'warehouse',
                                        name: 'app.InventoryManagement/WarehouseSetup',
                                        component: Warehouse,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.WarehouseList,
                                            clickable: true
                                        },

                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/warehouse-setup/warehouse',
                                                component: WarehouseList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.WarehouseList,
                                                    hide: true
                                                }
                                            },
                                            {
                                                path: 'new-warehouse',
                                                name: '/inventory-management/warehouse-setup/warehouse/new-warehouse',
                                                component: NewWarehouse,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewWarehouse
                                                }
                                            },
                                            {
                                                path: 'edit-warehouse',
                                                name: '/inventory-management/warehouse-setup/warehouse/new-warehouse',
                                                component: NewWarehouse,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.WarehouseUpdate
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'warehouse-category',
                                        name: '/inventory-management/warehouse-setup',
                                        component: WarehouseCategory,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.WarehouseCategory
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/warehouse-setup/warehouse-category',
                                                component: WarehouseCategoryList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.WarehouseCategoryList,
                                                    hide:true
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'products-limits',
                                        name: '/inventory-management/warehouse-setup/products-limits',
                                        component: ProductsLimits,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ProductsLimits
                                        }
                                    },
                                    {
                                        path: 'items-tracking-modifications',
                                        name: '/inventory-management/warehouse-setup/items-tracking',
                                        component: ItemsTracking,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ItemsTracking
                                        }
                                    },
                                    {
                                        path: 'warehouse-location',
                                        component: WarehouseLocation,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.WarehouseLocation,
                                            clickable: true
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/setups/warehouse-setup/warehouse-location',
                                                component: WarehouseLocationList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.WarehouseLocationList,
                                                    hide: true
                                                }
                                            },
                                            {
                                                path: 'new-warehouse-location',
                                                name: '/inventory-management/setups/warehouse-setup/warehouse-location/new-warehouse-location',
                                                component: NewWarehouseLocation,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewWarehouseLocation,
                                                }
                                            },
                                            {
                                                path: 'edit-warehouse-location',
                                                name: '/inventory-management/setups/warehouse-setup/warehouse-location/edit-warehouse-location',
                                                component: EditWarehouseLocation,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.EditWarehouseLocation,
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: 'product-setup',
                                component: PdtSetup,
                                meta: {
                                    title: translation[lang].Nav.Inventory.ProductSetup
                                },
                                children: [
                                    {
                                        path: 'materials-bill',
                                        name: '/inventory-management/setups/product-setup/materials-bill',
                                        component: MaterialsBill,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.MaterialsBill,
                                        }
                                    },
                                    {
                                        path: 'product-category',
                                        name: '/product-setup/product-category',
                                        component: ProductCategory,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ProductCategory,
                                            clickable:true
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/product-setup/product-category',
                                                component: ProductCategoryList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.ProductCategory,
                                                    hide:true
                                                }
                                            },
                                            {
                                                path: 'new-product-category',
                                                name: '/inventory-management/product-setup/new-product-category',
                                                component: NewProductCategory,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewProductCategory
                                                }
                                            },
                                            {
                                                path: 'edit-product-category',
                                                name: '/inventory-management/product-setup/new-product-category',
                                                component: NewProductCategory,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.EditProductCategory
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'products-list',
                                        name: '/inventory-management/product-setup/products-list',
                                        component: Products,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.Products,
                                            clickable:true
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/product-setup/products-list',
                                                component: ProductsList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.Products,
                                                    hide:true
                                                }
                                            },
                                            {
                                                path: 'new-product',
                                                name: '/inventory-management/product-setup/new-product',
                                                component: NewProduct,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewProduct
                                                }
                                            },
                                            {
                                                path: 'edit-product',
                                                name: '/inventory-management/product-setup/new-product',
                                                component: NewProduct,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.ProductUpdate
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'uom-category',
                                        name: '/inventory-management/product-setup/uom-category',
                                        component: UOMCategory,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.UOMCategory
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/inventory-management/product-setup/uom-category',
                                                component: UOMCategory,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.UOMCategory,
                                                    hide:true
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'classification-assignment',
                                        component: ClassificationAssignment,
                                        name: '/inventory-management/product-setup/classification-assignment',
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ClassificationAssignment
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'data-migration',
                                component: BulkSetup,
                                name: '/inventory-management/data-migration',
                                meta: {
                                    title: translation[lang].Nav.Inventory.DataMigration
                                }
                                //,
                                //children: [
                                //    {
                                //        path: 'bulk-migration',
                                //        name: '/inventory-management/bulk-setup/bulk-migration',
                                //        component: BulkMigration,
                                //        meta: {
                                //            title: translation[lang].Nav.Inventory.BulkMigration
                                //        }
                                //    }
                                //]
                            },
                        ]
                    },
                    {
                        path: 'inventory-operations',
                        component: IMOperations,
                        meta: {
                            title: translation[lang].Nav.Inventory.Operations
                        },
                        children: [
                            {
                                path: 'internal-request',
                                component: InternalRequest,
                                meta: {
                                    title: translation[lang].Nav.Inventory.InternalRequestList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/internal-request',
                                        component: InternalRequestList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.InternalRequestList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-internal-request',
                                        component: NewInternalRequest,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewInternalRequest
                                        }
                                    },
                                    {
                                        path: 'edit-internal-request',
                                        component: NewInternalRequest,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.InternalRequestUpdate
                                        }
                                    },
                                    {
                                        path: 'view-internal-request',
                                        component: NewInternalRequest,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewInternalRequest
                                        }
                                    }
                                ]
                            },
                            // Purchase Requistion
                            {
                                path: 'purchase-requistion',
                                component: PurchaseRequistion,
                                meta: {
                                    title: translation[lang].Nav.Inventory.PurchaseRequisitionList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: 'new-purchase-requistion',
                                        component: NewPurchaseRequistion,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewPurchaseRequistion
                                        }
                                    },
                                    {
                                        path: 'edit-purchase-requistion',
                                        component: NewPurchaseRequistion,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.PurchaseRequistionUpdate
                                        }
                                    },
                                    {
                                        path: 'view-purchase-requistion',
                                        component: NewPurchaseRequistion,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewPurchaseRequisition
                                        }
                                    },
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/purchase-requistion',
                                        component: PurchaseRequistionList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.PurchaseRequisitionList,
                                            hide: true
                                        }
                                    }
                                ]
                            },
                            // Stock Count
                            {
                                path: 'stock-count',
                                component: StockCount,
                                meta: {
                                    title: translation[lang].Nav.Inventory.StockCountList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/stock-count',
                                        component: StockCountList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.StockCountList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-stock-count-from-excel',
                                        name: '/inventory-management/inventory-operations/stock-count/new-stock-count',
                                        component: NewStockCount,
                                        meta: {
                                           title: translation[lang].Nav.Inventory.NewStockCountExcel
                                        }
                                    },
                                    {
                                        path: 'new-stock-count-from-browser',
                                        name: '/inventory-management/inventory-operations/stock-count/new-stock-count-from-browser',
                                        component: NewStockCountFromBrowser,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewStockCountBrowser
                                        }
                                    },
                                    {
                                        path: 'edit-stock-count-from-browser',
                                        name: '/inventory-management/inventory-operations/stock-count/new-stock-count-from-browser',
                                        component: NewStockCountFromBrowser,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.EditStockCountBrowser
                                        }
                                    },
                                    {
                                        path: 'view-stock-count-from-browser',
                                        name: '/inventory-management/inventory-operations/stock-count/view-stock-count-from-browser',
                                        component: NewStockCountFromBrowser,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewStockCountBrowser
                                        }
                                    }
                                    
                                ]
                            },
                            // Transfer Out
                            {
                                path: 'transfer-out',
                                component: TransferOut,
                                meta: {
                                    title: translation[lang].Nav.Inventory.TransferOutList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/transfer-out',
                                        component: TransferOutList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.TransferOutList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-transfer-out',
                                        component: NewTransferOut,
                                        name:'/inventory-management/inventory-operations/transfer-out/new-transfer-out',
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewTransfer
                                        }
                                    },
                                    {
                                        path: 'update-transfer-out',
                                        component: NewTransferOut,
                                        name: '/inventory-management/inventory-operations/transfer-out/update-transfer-out',

                                        meta: {
                                            title: translation[lang].Nav.Inventory.EditTransferOut
                                        }
                                    },
                                    {
                                        path: 'view-transfer-out',
                                        name: '/inventory-management/inventory-operations/transfer-out',
                                        component: NewTransferOut,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewTransfer
                                        }
                                    }
                                ]
                            },
                            // Transfer In
                            {
                                path: 'transfer-in',
                                component: TransferIn,
                                meta: {
                                    title: translation[lang].Nav.Inventory.TransferInList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/transfer-in',
                                        component: TransferInList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.TransferInList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-transfer-in',
                                        name: '/inventory-management/inventory-operations/transfer-in/new-transfer-in',
                                        component: NewTransferIn,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.TransferIn
                                        }
                                    },
                                    {
                                        path: 'view-transfer-in',
                                        name: '/inventory-management/inventory-operations/transfer-in/new-transfer-in',
                                        component: NewTransferIn,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewTransferIn
                                        }
                                    }
                                ]
                            },
                            // Returns to WH
                            {
                                path: 'returns',
                                component: ReturnsToWH,
                                meta: {
                                    title: translation[lang].Nav.Inventory.Returnss,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/returns',
                                        component: ReturnsToWHList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ReturnList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'receive-return',
                                        name: '/inventory-management/inventory-operations/returns/receive-return',
                                        component: ReceiveReturn,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ReceiveReturn
                                        }
                                    },
                                    {
                                        path: 'view-receive-return',
                                        name: '/inventory-management/inventory-operations/returns/receive-return',
                                        component: ReceiveReturn,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewReceiveReturn
                                        }
                                    }
                                ]
                            },
                            // Returns to Vendor
                            {
                                path: 'return-to-vendor',
                                component: ReturnToVendor,
                                meta: {
                                    title: translation[lang].Nav.Inventory.ReturnToVendorr,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/return-to-vendor',
                                        component: ReturnToVendorList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ReturnToVendorList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-return-to-vendor',
                                        name: '/inventory-management/inventory-operations/return-to-vendor/new-return-to-vendor',
                                        component: NewReturnToVendor,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewReturnToVendor
                                        }
                                    },
                                    {
                                        path: 'edit-return-to-vendor',
                                        name: '/inventory-management/inventory-operations/return-to-vendor/edit-return-to-vendor',
                                        component: NewReturnToVendor,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.EditReturnToVendor
                                        }
                                    },
                                    {
                                        path: 'view-return-to-vendor',
                                        name: '/inventory-management/inventory-operations/return-to-vendor',
                                        component: NewReturnToVendor,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewReturnToVendor
                                        }
                                    }
                                ]
                            },
                            // Goods Receipt
                            {
                                path: 'goods-receipt',
                                component: GoodsReceipt,
                                meta: {
                                    title: translation[lang].Nav.Inventory.GoodsReceiptList,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/goods-receipt',
                                        component: GoodsReceiptList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.GoodsReceiptList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-goods-receipt',
                                        name: '/inventory-management/inventory-operations/goods-receipt/new-goods-receipt',
                                        component: NewGoodsReceipt,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewGoodsReceipt
                                        }
                                    },
                                    {
                                        path: 'edit-goods-receipt',
                                        name: '/inventory-management/inventory-operations/goods-receipt/new-goods-receipt',
                                        component: NewGoodsReceipt,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.GoodsReceiptUpdate
                                        }
                                    },
                                    {
                                        path: 'view-goods-receipt',
                                        name: '/inventory-management/inventory-operations/goods-receipt',
                                        component: NewGoodsReceipt,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewGoodsReceipt
                                        }
                                    }
                                ]
                            },
                            //receive IR
                            {
                                path: 'receive-ir',
                                component: ReceiveIR,
                                meta: {
                                    title: translation[lang].Nav.Inventory.ReceiveIR,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/receive-ir',
                                        component: ReceiveIRList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ReceiveIR,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'receive-ir-request',
                                        name:'/inventory-management/inventory-operations/receive-ir/receive-ir',
                                        component: ReceiveIRRequest,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ReceiveIR
                                        }
                                    }
                                    
                                ]
                            },
                            // Goods Receipt
                            {
                                path: 'manufacturing-orders',
                                component: ManufacturingOrders,
                                meta: {
                                    title: translation[lang].Nav.Inventory.ManufacturingOrders,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/manufacturing-orders',
                                        component: ManufacturingOrdersList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ManufacturingOrders,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-manufacturing-order',
                                        component: NewManufacturingOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewManufacturingOrder
                                        }
                                    },
                                    {
                                        path: 'view-manufacturing-order',
                                        name: '/inventory-management/inventory-operations/manufacturing-orders',
                                        component: NewManufacturingOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewManufacturingOrder
                                        }
                                    }
                                ]
                            },
                            // Donations
                            {
                                path: 'donations',
                                component: Donations,
                                meta: {
                                    title: translation[lang].Nav.Inventory.Donations,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/donations',
                                        component: DonationsList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.DonationsList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'view-donation',
                                        name: '/inventory-management/inventory-operations/donations/view-donation',
                                        component: ViewDonation,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewDonation
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'internal-transfer',
                                component: InternalTransfer,
                                meta: {
                                    title: translation[lang].Nav.Inventory.InternalTransfer,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/internal-transfer',
                                        component: InternalTransferList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.InternalTransferList,
                                            hide: true
                                        }
                                    },
                                    {
                                        path: 'new-internal-transfer',
                                        name: '/inventory-management/inventory-operations/internal-transfer/new-internal-transfer',
                                        component: NewInternalTransfer,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewInternalTransfer,
                                        }
                                    },
                                    {
                                        path: 'view-internal-transfer',
                                        name: '/inventory-management/inventory-operations/internal-transfer/view-internal-transfer',
                                        component: NewInternalTransfer,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewInternalTransfer,
                                        }
                                    }
                                ]
                            },
                            // Rsd Notifications 
                            {
                                path: 'rsd-notifications',
                                component: RsdNotifications,
                                meta: {
                                    title: translation[lang].Nav.Inventory.RsdNotifications,
                                    clickable: true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: '/inventory-management/inventory-operations/rsd-notifications',
                                        component: RsdNotificationsList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.RsdNotifications,
                                            hide: true
                                        }
                                    }
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                path: 'purchase-management',
                name: 'PurchaseManagement',
                component: PurchaseManagement,
                meta: {
                    title: translation[lang].Nav.Inventory.PurchaseManagement
                },
                children: [
                    // Purchase Management
                    {
                        path: 'purchase-operations',
                        component: PurchaseOperations,
                        meta: {
                            title: translation[lang].Nav.Inventory.Operations
                        },
                        children: [
                            {
                                path: 'purchase-orders',
                                component: PurchaseOrders,
                                meta: {
                                    title: translation[lang].Nav.Inventory.PurchaseOrdersList,
                                    clickable:true
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'purchase-management/purchase-operations/purchase-orders',
                                        component: PurchaseOrdersList,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.PurchaseOrdersList,
                                            hide:true
                                        }
                                    },
                                    {
                                        path: 'new-purchase-order',
                                        name: 'purchase-management/purchase-operations/purchase-orders/new-purchase-order',
                                        component: NewPurchaseOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.NewPurchaseOrder
                                        }
                                    },
                                    {
                                        path: 'edit-purchase-order',
                                        name: 'purchase-management/purchase-operations/purchase-orders/new-purchase-order',
                                        component: NewPurchaseOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.PurchaseOrderUpdate
                                        }
                                    },
                                    {
                                        path: 'validate-purchase-order',
                                        name: 'purchase-management/purchase-operations/purchase-orders/validate-purchase-order',
                                        component: NewPurchaseOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.PurchaseOrderValidation
                                        }
                                    },
                                    {
                                        path: 'view-purchase-order',
                                        name: 'purchase-management/purchase-operations/purchase-orders/view-purchase-order',
                                        component: ViewPurchaseOrder,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.ViewPurchaseOrder
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'requisitions',
                                component: Requisitions,
                                meta: {
                                    title: translation[lang].Nav.Inventory.RequisitionsList,
                                    hide: true
                                },
                                children: [{
                                    path: '',
                                    name: 'purchase-management/purchase-operations/requisitions',
                                    component: RequisitionsList,
                                    meta: {
                                        title: translation[lang].Nav.Inventory.RequisitionsList
                                    }
                                }]
                            }
                        ]
                    },
                    {
                        path: 'setups',
                        component: PMSetups,
                        meta: {
                            title: translation[lang].Nav.Inventory.Setups
                        },
                        children: [
                            {
                                path: 'vendor-setup',
                                component: VendorSetup,
                                meta: {
                                    title: translation[lang].Nav.Inventory.VendorSetup
                                },
                                children: [
                                    {
                                        path: 'vendor',
                                        component: vendor,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.Vendors,
                                            clickable:true
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: '/purchase-management/setups/vendor-setup/vendor',
                                                component: VendorList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.VendorList,
                                                    hide:true
                                                }
                                            },
                                            {
                                                path: 'new-vendor',
                                                component: NewVendor,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewVendor
                                                }
                                            },
                                            {
                                                path: 'edit-vendor',
                                                component: NewVendor,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.EditVendor
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'vendor-group',
                                        component: vendorGroup,
                                        meta: {
                                            title: translation[lang].Nav.Inventory.VendorsGroup,
                                            clickable:true
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: 'purchase-management/setups/vendor-setup/vendor-group',
                                                component: vendorGroupList,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.VendorGroupList,
                                                    hide:true
                                                }
                                            },
                                            {
                                                path: 'new-vendor-group',
                                                name: 'purchase-management/setups/vendor-setup/vendor-group/new-vendor-group',
                                                component: NewVendorGroup,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.NewVendorGroup
                                                }
                                            },
                                            {
                                                path: 'edit-vendor-group',
                                                name: 'purchase-management/setups/vendor-setup/vendor-group/new-vendor-group',
                                                component: NewVendorGroup,
                                                meta: {
                                                    title: translation[lang].Nav.Inventory.EditVendorGroup
                                                }
                                            }
                                        ]
                                    },
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        beforeEnter: guardRoute
    }
];

export default inventoryManagementRoutes;
